var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { CanvasPrintProduct } from "@rendering/vortex-canvas-prints";
import { loadSubstrateMap } from "./materialLoader";
export function getCanvasPrintProduct(productConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g;
    const response = yield fetch(productConfig.productDataUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch CanvasPrintData from '".concat(productConfig.productDataUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch CanvasPrintData from '".concat(productConfig.productDataUrl, "'!"));
    }
    const canvasPrintData = yield response.json();
    // Load all the substrates
    const substrateMap = yield loadSubstrateMap(productConfig);
    const {
      surfaceMapping
    } = productConfig;
    // Validate surfaces exist for the canvas and interior frame
    if (!surfaceMapping.canvas || !surfaceMapping.interiorFrame) {
      throw new Error("The surface mapping must contain surfaces for canvas and interiorFrame!");
    }
    // Fill out the required options for canvas prints
    const canvasPrintConfig = {
      fullBleed: canvasPrintData.fullBleed,
      trim: canvasPrintData.trim,
      depth: canvasPrintData.depth,
      fabricSubstrate: substrateMap[surfaceMapping.canvas.substrateId],
      interiorOptions: {
        frameOptions: {
          thickness: canvasPrintData.interiorOptions.frameOptions.thickness,
          substrate: substrateMap[surfaceMapping.interiorFrame.substrateId]
        }
      }
    };
    // Add covers if they exist
    if ((_b = canvasPrintData.exteriorOptions) === null || _b === void 0 ? void 0 : _b.cover) {
      if (!surfaceMapping.cover) {
        throw new Error("The surface mapping is missing a cover!");
      }
      canvasPrintConfig.exteriorOptions = {
        cover: {
          substrate: substrateMap[surfaceMapping.cover.substrateId],
          depth: canvasPrintData.exteriorOptions.cover.depth
        }
      };
    }
    // Add exterior frames if they exist
    if ((_c = canvasPrintData.exteriorOptions) === null || _c === void 0 ? void 0 : _c.frameOptions) {
      if (!surfaceMapping.exteriorFrame) {
        throw new Error("The surface mapping is missing an exteriorFrame!");
      }
      const exteriorFrameOptions = {
        substrate: substrateMap[surfaceMapping.exteriorFrame.substrateId],
        inner: {
          depth: (_d = canvasPrintData.exteriorOptions) === null || _d === void 0 ? void 0 : _d.frameOptions.inner.depth,
          thickness: (_e = canvasPrintData.exteriorOptions) === null || _e === void 0 ? void 0 : _e.frameOptions.inner.thickness
        },
        outer: {
          depth: (_f = canvasPrintData.exteriorOptions) === null || _f === void 0 ? void 0 : _f.frameOptions.outer.depth,
          thickness: (_g = canvasPrintData.exteriorOptions) === null || _g === void 0 ? void 0 : _g.frameOptions.outer.thickness
        }
      };
      // If a external frame options where already defined with a cover add them
      if (canvasPrintConfig.exteriorOptions) {
        canvasPrintConfig.exteriorOptions.frameOptions = exteriorFrameOptions;
      } else {
        canvasPrintConfig.exteriorOptions = {
          frameOptions: exteriorFrameOptions
        };
      }
    }
    return new CanvasPrintProduct(canvasPrintConfig);
  });
}